
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkManagerAuth } from "@/utils/managerAuth";
import HomeHeader from "@/components/home/HomeHeader";
import HeroSection from "@/components/home/HeroSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import BenefitsSection from "@/components/home/BenefitsSection";
import CTASection from "@/components/home/CTASection";
import HomeFooter from "@/components/home/HomeFooter";

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isAuthenticated = await checkManagerAuth();
        if (isAuthenticated) {
          navigate("/manager/dashboard");
        }
      } catch (error) {
        console.error("Auth check failed on homepage:", error);
        // Don't redirect or show error, just continue with homepage
      }
    };
    
    checkAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F4F6F8] to-[#E6EEF5]">
      <HomeHeader />
      <HeroSection />
      <FeaturesSection />
      <BenefitsSection />
      <CTASection />
      <HomeFooter />
    </div>
  );
};

export default HomePage;
